import "./color-picker-input.scss";
import { observer } from "mobx-react";

interface IProps {
    value?: string;
    onChange?: (value: string) => void;
}
const ColorPickerInput: React.FC<IProps> = observer(({ value, onChange }) => {
    const stripHashPrefix = (raw: string): string => raw.trim().replace(/^#+/, '');

    const hadleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = stripHashPrefix(e.target.value as string);
        onChange && onChange(value);
    }

    const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = stripHashPrefix(e.target.value as string);
        onChange && onChange(value);
    }

    const getValue = () => {
        if (value === undefined || value === null) {
            return '#';
        }
        return `#${value}`;
    }
    
    return (
        <div className="color-picker-input">
            <input type="text" value={getValue()} onChange={hadleTextChange} />
            <input type="color" value={getValue()} onChange={handleColorChange}></input>
        </div>
    );
});

export default ColorPickerInput;